/**
 * Timesheet model for a single timesheet line returned by hq_rpc_middleware.
 *
 * The middleware sends relations as {id, name} objects; raw Odoo [id, name]
 * pairs and bare ids are accepted too so the model survives either source.
 */
const relId = (value) => {
  if (Array.isArray(value)) return value[0] ?? null;
  if (value && typeof value === 'object') return value.id ?? null;
  return value ?? null;
};

const relName = (value) => {
  if (Array.isArray(value)) return value[1] ?? null;
  if (value && typeof value === 'object') return value.name ?? null;
  return null;
};

export class Timesheet {
  constructor({
    id = null,
    date = null,
    description = null,
    timeSpent = null,
    hours = 0,
    taskId = null,
    taskName = null,
    projectId = null,
    projectName = null,
    employeeId = null,
    employeeName = null,
    attachments = [],
    audio = [],
  } = {}) {
    this.id = id;
    this.date = date;
    this.description = description;
    this.timeSpent = timeSpent;
    this.hours = hours;
    this.taskId = taskId;
    this.taskName = taskName;
    this.projectId = projectId;
    this.projectName = projectName;
    this.employeeId = employeeId;
    this.employeeName = employeeName;
    this.attachments = attachments;
    this.audio = audio;
  }

  static fromJson(json = {}) {
    const task = json.task ?? json.task_id;
    const project = json.project ?? json.project_id;
    const employee = json.employee ?? json.employee_id;

    return new Timesheet({
      id: json.id ?? null,
      date: json.date ?? null,
      description: json.description ?? json.name ?? null,
      timeSpent: json.time_spent ?? null,
      hours: Number(json.unit_amount ?? json.hours ?? 0),
      taskId: relId(task),
      taskName: relName(task),
      projectId: relId(project),
      projectName: relName(project),
      employeeId: relId(employee),
      employeeName: relName(employee),
      attachments: Array.isArray(json.attachments) ? json.attachments : [],
      audio: Array.isArray(json.audio) ? json.audio : [],
    });
  }
}
